import React, { useState } from "react";
import styles from "./_css/scenarioHeader.module.css";
import downloadIcon from "../assets/icons/download.svg";
import { scenariosStore } from "./_stores/scenariosStore";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { CircularProgress } from "@material-ui/core";

interface Props {
    scenarioId: string;
}

export const ScenarioExportButton = ({ scenarioId }: Props) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const handleExport = async () => {
        try {
            setIsLoading(true);
            const blob = await scenariosStore.export(scenarioId);

            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${t("words.history").toLowerCase()}_${new Date().toISOString().slice(0, 10)}.zip`;
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);

            toast.info(t("scenarioPage.export"), {
                position: "bottom-center",
            });
        } catch (error) {
            toast.error(t("scenarioPage.exportError") || "Erreur lors de l'export", {
                position: "bottom-center",
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div onClick={handleExport} className={styles.contentIcons} style={{ cursor: "pointer" }}>
            {isLoading ? (
                <CircularProgress size={24} />
            ) : (
                <img title={"export"} className={styles.icons} src={downloadIcon} alt={"export icon"} />
            )}
        </div>
    );
};
